<div class="p-8">
  <div class="flex justify-between items-center mb-6">
    <h1 class="text-3xl font-bold text-gray-900">Profiles</h1>
    <div class="flex items-center space-x-3">
      <div class="flex bg-gray-200 rounded-md p-0.5">
        <button 
          (click)="viewMode = 'list'" 
          [class]="viewMode === 'list' ? 'bg-white shadow text-gray-900' : 'text-gray-500 hover:text-gray-700'"
          class="px-3 py-1.5 rounded text-sm font-medium transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
        <button 
          (click)="viewMode = 'cards'" 
          [class]="viewMode === 'cards' ? 'bg-white shadow text-gray-900' : 'text-gray-500 hover:text-gray-700'"
          class="px-3 py-1.5 rounded text-sm font-medium transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM14 5a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4zM14 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"></path>
          </svg>
        </button>
      </div>
      <button (click)="addProfile()" class="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">
        Add New Profile
      </button>
    </div>
  </div>
  
  <app-spinner *ngIf="loading"></app-spinner>

  <div *ngIf="!loading && profiles.length === 0" class="text-gray-500">No profiles found.</div>

  <!-- List View -->
  <div *ngIf="!loading && viewMode === 'list' && profiles.length > 0" class="bg-white rounded-lg shadow overflow-hidden">
    <div #listContainer>
      <div 
        *ngFor="let profile of profiles; let i = index; trackBy: trackById" 
        class="flex items-center px-6 py-4 border-b border-gray-200 last:border-b-0 hover:bg-gray-50">
        <div class="drag-handle mr-4 text-gray-400 hover:text-gray-600 cursor-grab">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h16M4 16h16"></path>
          </svg>
        </div>
        <div class="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center overflow-hidden mr-4 flex-shrink-0">
          <img *ngIf="profile.image?.src" [src]="profile.image.src" [alt]="profile.name" class="w-full h-full object-cover">
          <svg *ngIf="!profile.image?.src" class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
        </div>
        <div class="flex-1 min-w-0">
          <h3 class="text-sm font-medium text-gray-900">{{ profile.name }}</h3>
          <p *ngIf="profile.title" class="text-sm text-gray-500">{{ profile.title }}</p>
        </div>
        <div class="flex items-center space-x-3 ml-4">
          <button (click)="editProfile(profile._id)" class="text-blue-600 hover:text-blue-900 text-sm">Edit</button>
          <button (click)="confirmDelete(profile)" class="text-red-600 hover:text-red-900 text-sm">Delete</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Card View -->
  <div *ngIf="!loading && viewMode === 'cards' && profiles.length > 0" #cardsContainer class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    <div *ngFor="let profile of profiles; trackBy: trackById" class="bg-white rounded-lg shadow p-6 cursor-move">
      <div class="flex items-center space-x-4">
        <div class="drag-handle flex items-center text-gray-400 hover:text-gray-600 cursor-grab">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h16M4 16h16"></path>
          </svg>
        </div>
        <div class="w-12 h-12 bg-gray-300 rounded-full flex items-center justify-center overflow-hidden">
          <img *ngIf="profile.image?.src" [src]="profile.image.src" [alt]="profile.name" class="w-full h-full object-cover">
          <svg *ngIf="!profile.image?.src" class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
        </div>
        <div>
          <h3 class="text-lg font-medium text-gray-900">{{ profile.name }}</h3>
          <p *ngIf="profile.title" class="text-sm text-gray-500">{{ profile.title }}</p>
        </div>
      </div>
      <div class="mt-4 flex space-x-2">
        <button (click)="editProfile(profile._id)" class="text-blue-600 hover:text-blue-900 text-sm">Edit</button>
        <button (click)="confirmDelete(profile)" class="text-red-600 hover:text-red-900 text-sm">Delete</button>
      </div>
    </div>
  </div>
</div>

<app-confirmation-modal
  [show]="showDeleteModal"
  title="Delete Profile"
  [message]="'Are you sure you want to delete ' + ((profileToDelete?.firstName || '') + ' ' + (profileToDelete?.surname || '') || 'this profile') + '?'"
  confirmText="Delete"
  (confirm)="deleteProfile()"
  (cancel)="cancelDelete()">
</app-confirmation-modal>
